declare namespace $ {

	type $mol_paragraph__title_idle_app_dice_1 = $mol_type_enforce<
		ReturnType< $idle_app_dice['money_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_idle_app_dice_2 = $mol_type_enforce<
		ReturnType< $idle_app_dice['dice_result_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_idle_app_dice_3 = $mol_type_enforce<
		ReturnType< $idle_app_dice['dice_value_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_idle_app_dice_4 = $mol_type_enforce<
		ReturnType< $idle_app_dice['dice_level_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_idle_app_dice_5 = $mol_type_enforce<
		ReturnType< $idle_app_dice['dice_up'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_list__rows_idle_app_dice_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_row__sub_idle_app_dice_7 = $mol_type_enforce<
		ReturnType< $idle_app_dice['dice_list'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_row__sub_idle_app_dice_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_button_major__title_idle_app_dice_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	export class $idle_app_dice extends $mol_page {
		money_label( ): string
		Money( ): $mol_paragraph
		dice_result_label( id: any): string
		Dice_result( id: any): $mol_paragraph
		dice_value_label( id: any): string
		Dice_value( id: any): $mol_paragraph
		dice_level_label( id: any): string
		Dice_level( id: any): $mol_paragraph
		dice_up( id: any): string
		Dice_up( id: any): $mol_button_major
		Dice_box( id: any): $mol_list
		dice_list( ): readonly(any)[]
		Dice_list( ): $mol_row
		Dice_row( ): $mol_row
		Roll( ): $mol_button_major
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=dice.view.tree.d.ts.map